<template>
  <div class="container">
    <div class="information">
      当前就诊人：{{ defaultPatient }}
      <button @click="selectPatient">切换</button>
    </div>
    <van-tabs v-model="active" @click="checkTabs">
      <van-tab title="未缴费">
        <div class="tab-container">
          <div
            class="bill-item"
            v-for="(preItem, index) in payList"
            :key="index"
            @click="toSelectPre(preItem, 0)"
          >
            <div class="bill-cell">
              <div class="bill-cell-label">就诊时间：</div>
              <div class="bill-cell-text">
                {{ preItem[0].clinicTime.slice(0, 10) }}
              </div>
            </div>
            <div class="bill-cell">
              <div class="bill-cell-label">就诊科室：</div>
              <div class="bill-cell-text">
                {{ preItem[0].deptName }}
              </div>
            </div>
            <div class="bill-cell">
              <div class="bill-cell-label">就诊号：</div>
              <div class="bill-cell-text">{{ preItem[0].hisOrdNum }}</div>
            </div>
            <div class="jfbun">
              <van-button type="info" size="normal"> 缴费 </van-button>
            </div>
          </div>
          <div class="pay-content"></div>
          <van-empty
            v-if="!payList.length"
            class="custom-image"
            image="https://img.yzcdn.cn/vant/custom-empty-image.png"
            description="暂无数据"
          />
        </div>
      </van-tab>
      <van-tab title="已缴费">
        <div class="tab-container">
          <div
            class="bill-item"
            v-for="(preItem, index) in payedList"
            :key="index"
            @click="toSelectPre(preItem, 1)"
          >
            <!-- <img v-if="preItem.data[0].tui == 1" src="../../assets/refund.png" class="refund"> -->

            <div class="bill-cell" v-if="preItem">
              <div class="bill-cell-label">就诊时间：</div>
              <div class="bill-cell-text">
                {{ preItem.OperDate }}
              </div>
              <div class="jfbun">
                <span v-if="preItem.CancelFlag === '0'" class="cancel-span"
                  >已退费
                </span>
              </div>
            </div>
            <div class="bill-cell" v-if="preItem">
              <div class="bill-cell-label">就诊科室：</div>
              <div class="bill-cell-text">
                {{ preItem.InvDetail[0].DeptName }}
              </div>
            </div>
            <div class="bill-cell" v-if="preItem">
              <div class="bill-cell-label">就诊号：</div>
              <div class="bill-cell-text">
                {{ preItem.ClinicCode }}
              </div>
              <div class="jfbun">
                <span class="jfbun-span">查看 ></span>
              </div>
            </div>
          </div>
          <div class="pay-content"></div>
          <van-empty
            v-if="!payedList.length"
            class="custom-image"
            image="https://img.yzcdn.cn/vant/custom-empty-image.png"
            description="暂无数据"
          />
        </div>
      </van-tab>
    </van-tabs>
    <div v-if="active == 1" class="search">
      <div class="circular"></div>
      <div
        class="searchList"
        :class="SListState ? '' : 'animation'"
        v-if="SListState == false"
        @click="searchselect(0)"
      >
        <div>{{ searchname }}</div>
      </div>
      <div
        v-if="SListState"
        class="searchList"
        :class="SListState ? 'animation' : ''"
      >
        <div
          v-for="item in SList"
          :key="item.id"
          @click="searchselect(1, item)"
        >
          {{ item.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDefaultPatient, getUnExtFeeList, getExtFeeList } from '@/api/api'
export default {
  data() {
    return {
      active: 0,
      defaultPatient: '',
      patientId: '',
      payList: [],
      payedList: [],
      SListState: false,
      searchname: '近三个月',
      SList: [
        {
          value: '近三个月',
          id: '0'
        },
        {
          value: '近半年',
          id: '1'
        },
        {
          value: '近一年',
          id: '2'
        }
      ]
    }
  },
  created() {},
  mounted() {
    if (this.$route.query.active) this.active = this.$route.query.active
    if (this.$route.query.patientId) {
      this.defaultPatient = this.$route.query.patientName
      this.patientId = this.$route.query.patientId
      this.getData(this.$route.query.patientId)
    } else {
      this.getList()
    }
  },
  methods: {
    searchselect(v, item) {
      if (v == 0) {
        this.SListState = true
      } else {
        getExtFeeList({ patientId: this.patientId, type: item.id }).then(
          res => {
            if (res.code === 200) {
              this.payedList = JSON.parse(res.msg).body
              this.payedList = this.payedList.map(item => {
                item.OperDate = item.OperDate.slice(0, 10).replace(/\//g, '-')
                return item
              })
            }
            this.searchname = item.value
            this.SListState = false
          }
        )
      }
    },
    toSelectPre(i, v) {
      if (v == 0) {
        this.$router.push({
          name: 'selectpre',
          params: {
            patientName: this.defaultPatient,
            patientId: this.patientId,
            ...this.$route.query,
            clinic: i[0].hisOrdNum,
            sum: i.sum,
            data: i,
            pre: this.active,
            code: v
          }
        })
      }
      if (v == 1) {
        this.$router.push({
          name: 'selectpre',
          params: {
            patientId: this.patientId,
            patientName: this.defaultPatient,
            item: i,
            // receiptNO: i.receipt_NO,
            // // billNo:i.billNo,
            // billqrcode: i.billqrcode,
            code: v
          }
        })
      }
    },
    getList() {
      getDefaultPatient().then(res => {
        if (res.data && res.data.length == 1) {
          this.defaultPatient = res.data[0].patientName
          this.patientId = res.data[0].patientId
          this.getData()
        } else {
          this.defaultPatient = '暂无就诊人，请选择'
          this.patientId = ''
        }
      })
    },
    // 切换就诊人
    selectPatient() {
      this.$router.push({
        name: 'patientList',
        query: {
          select: 'list'
        }
      })
    },
    // tab
    checkTabs(name, title) {
      this.active = name
      this.getData()
    },
    // 获取数据
    getData() {
      this.payList = []
      this.payedList = []
      if (this.patientId != '') {
        this.active == 0
          ? getUnExtFeeList({ patientId: this.patientId }).then(res => {
              if (res.code === 200) {
                let list = JSON.parse(res.msg).body.feeList

                const newList = list.reduce((acc, item) => {
                  // 检查acc中是否已经有当前id的数组
                  if (!acc[item.payOrderNo]) {
                    // 如果没有，则初始化一个空数组
                    acc[item.payOrderNo] = []
                  }
                  // 将当前item添加到对应payOrderNo的数组中
                  acc[item.payOrderNo].push(item)
                  // 返回累加器，以便下一个迭代可以继续使用
                  return acc
                }, {})

                // 现在list是一个对象，其属性是payOrderNo，值是包含具有该payOrderNo的所有对象的数组
                // 如果你想要得到一个数组，其中每个元素都是具有相同payOrderNo的对象的数组
                const listArrays = Object.values(newList)
                this.payList = listArrays
              }
            })
          : getExtFeeList({ patientId: this.patientId, type: 0 }).then(res => {
              if (res.code === 200) {
                console.log(JSON.parse(res.msg))

                this.payedList = JSON.parse(res.msg).body

                this.payedList = this.payedList.map(item => {
                  item.OperDate = item.OperDate.slice(0, 10).replace(/\//g, '-')
                  return item
                })
              }
            })
      }
      // if (this.patientId != '') {
      //   let data = {
      //     patientId: this.patientId,
      //     queryType: this.active == 0 ? '1' : '2',
      //   }
      //   getHisPrescription(data).then((res) => {
      //     this.payList = JSON.parse(res.msg)
      //   })
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.information {
  color: #ffffff;
  background-color: rgb(8, 112, 253);
  padding: 7px 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.information button {
  background-color: #ffffff;
  font-size: 18px;
  color: rgb(79, 188, 251);
  border: 1px solid rgb(8, 112, 253);
  border-radius: 20px;
  padding: 3px 10px;
}

.tab-container {
  height: calc(100vh - 85px);
  background: rgb(242, 248, 253);
  overflow-y: auto;
}

.bill-item {
  width: 100vw;
  padding: 5px 15px;
  background: #fff;
  margin-bottom: 10px;
  position: relative;

  .refund {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 65px;
  }

  .bill-cell {
    width: 100%;
    display: flex;
    align-items: center;
    height: 30px;
    line-height: 30px;

    &-label {
      width: 100px;
      color: #666;
      display: flex;
      align-items: center;
      font-size: 18px;
    }

    &-text {
      width: calc(100% - 70px);
      font-size: 18px;
    }
  }

  .pay-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgb(234, 234, 234);

    &-label {
      color: #666;
      display: flex;
      align-items: center;
      font-size: 18px;

      .much {
        font-size: 18px;
        color: rgb(237, 125, 84);
        margin-left: 10px;
      }
    }

    &-text {
      display: flex;
      align-items: center;
      font-size: 18px;
    }
  }
}

.jfbun {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
.jfbun button {
  font-size: 16px;
  height: 40px;
}

.jfbun-span {
  font-size: 16px;
  color: #666;
  margin-top: 10px;
}
.cancel-span {
  font-size: 16px;
  color: red;
  margin-top: 10px;
}

.search {
  position: fixed;
  bottom: 20px;
  right: 0px;
  font-size: 18px;
}

.circular {
  width: 30px;
  height: 45px;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  background-color: rgb(128, 163, 252);
  display: block;
  float: left;
}

.select {
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  background-color: rgb(128, 163, 252);
  color: #ffffff;
  padding: 0 30px 0 0;
  height: 45px;
  line-height: 45px;
}

.animation {
  background-color: rgb(128, 163, 252);
  color: #ffffff;
  padding: 0 30px 0 0;
  height: 45px;
  line-height: 45px;

  div {
    padding-right: 10px;
  }
}

.searchList {
  display: flex;
}
</style>
<style lang="css" scope>
.van-tabs__line {
  width: 50%;
  height: 2px;
  background-color: #3478f7;
}
.van-tab__text--ellipsis {
  font-size: 18px;
}
.van-empty__description {
  font-size: 18px;
}
.custom-image .van-empty__image {
  width: 160px;
  height: 160px;
}
</style>
